var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.data && Object.keys(_vm.data).length > 0 && !_vm.isLoading ? _c('div', {
    staticClass: "por-dashboard"
  }, [_vm._m(0), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "timestamp",
    attrs: {
      "title": "Click to refresh the data"
    },
    on: {
      "click": _vm.getData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Updated " + _vm._s(_vm.getFormattedTime) + " "), _c('span', [_vm._v(_vm._s(_vm.getTimeElapsed))])]), _c('div', {
    staticClass: "key-metrics-summary"
  }, [_c('div', {
    staticClass: "metric-card"
  }, [_c('div', {
    staticClass: "metric-title"
  }, [_vm._v("USDtb Collateralization Ratio")]), _vm.collateralizationRatio > 100 ? _c('div', {
    staticClass: "metric-value"
  }, [_vm._v(" " + _vm._s(_vm.formatPercentage(_vm.collateralizationRatio)) + " ")]) : _c('vue-loaders-ball-beat', {
    attrs: {
      "color": "var(--redstone-red-color)",
      "scale": "0.5"
    }
  }), _c('div', {
    staticClass: "metric-subtitle"
  }, [_vm._v("Coverage of reserves to supply")])], 1), _c('div', {
    staticClass: "metric-card"
  }, [_c('div', {
    staticClass: "metric-title"
  }, [_vm._v("Grand Total")]), _c('div', {
    staticClass: "metric-value"
  }, [_vm._v(_vm._s(_vm.formatPreciseValue(_vm.grandTotal)))]), _c('div', {
    staticClass: "metric-subtitle"
  }, [_vm._v("Total backing assets")])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('div', {
    staticClass: "metric-title"
  }, [_vm._v("Total Supply")]), _c('div', {
    staticClass: "metric-value"
  }, [_vm._v(" " + _vm._s(_vm.formatPreciseValue(_vm.totalSupply, "")) + " ")]), _c('div', {
    staticClass: "metric-subtitle"
  }, [_vm._v("Circulating tokens")])])]), _c('div', {
    staticClass: "por-dashboard__content"
  }, [_c('div', {
    staticClass: "two-column"
  }, [_c('div', {
    staticClass: "card distribution-chart"
  }, [_vm._m(1), _c('div', {
    staticClass: "card-body"
  }, [_c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "300",
      "options": _vm.distributionChartOptions,
      "series": _vm.distributionChartSeries
    }
  })], 1)]), _c('div', {
    staticClass: "card exchange-chart"
  }, [_vm._m(2), _c('div', {
    staticClass: "card-body"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.exchangeChartOptions,
      "series": _vm.exchangeChartSeries
    }
  })], 1)])]), _c('div', {
    staticClass: "card assets-in-motion"
  }, [_vm._m(3), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "assets-motion-container"
  }, [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "motion-info",
    attrs: {
      "title": "Subscription & Redemption of BUIDL is not atomic. This means that for periods, usually a few hours, the backing assets can be waiting to receive BUIDL/USDC and as such this is why the assets aren't in the above addresses."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _c('div', {
    staticClass: "aim-value"
  }, [_vm._v(" " + _vm._s(_vm.formatPreciseValue(_vm.assetsInMotionValue)) + " ")])])])]), _c('div', {
    staticClass: "card custodians-panel"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h2', [_vm._v("Custodians")]), _c('button', {
    staticClass: "toggle-panel-btn",
    on: {
      "click": _vm.toggleCustodiansPanel
    }
  }, [_vm._v(" " + _vm._s(_vm.custodiansCollapsed ? "Show details" : "Hide details") + " ")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "custodian-tabs"
  }, _vm._l(_vm.visibleCustodians, function (custodian) {
    return _c('div', {
      key: custodian.id,
      staticClass: "custodian-tab",
      class: {
        active: _vm.activeTab === custodian.id
      },
      on: {
        "click": function click($event) {
          return _vm.setActiveTab(custodian.id);
        }
      }
    }, [_c('div', {
      staticClass: "provider-logo"
    }, [custodian.logo ? _c('img', {
      attrs: {
        "src": custodian.logo,
        "alt": custodian.name
      }
    }) : _c('i', {
      staticClass: "fa fa-cube",
      staticStyle: {
        "font-size": "30px",
        "color": "#565656"
      }
    })]), _c('div', {
      staticClass: "tab-content"
    }, [_c('div', {
      staticClass: "provider-name"
    }, [_vm._v(_vm._s(custodian.name))]), _c('div', {
      staticClass: "provider-balance"
    }, [_vm._v(" " + _vm._s(_vm.formatValue(_vm.calculateExchangeTotal(custodian.addressKey))) + " ")])])]);
  }), 0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.custodiansCollapsed,
      expression: "!custodiansCollapsed"
    }],
    staticClass: "custodian-details-panel"
  }, _vm._l(_vm.visibleCustodians, function (custodian) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.activeTab === custodian.id,
        expression: "activeTab === custodian.id"
      }],
      key: "detail-".concat(custodian.id),
      staticClass: "custodian-detail-view"
    }, [_c('div', {
      staticClass: "custodian-header"
    }, [_c('span'), custodian.website ? _c('a', {
      staticClass: "provider-link",
      attrs: {
        "href": custodian.website,
        "target": "_blank"
      }
    }, [_vm._v(" Visit " + _vm._s(custodian.name) + " "), _c('i', {
      staticClass: "fa fa-external-link"
    })]) : _c('span', {
      staticClass: "provider-identity"
    }, [_vm._v(_vm._s(custodian.name))])]), _c('div', {
      staticClass: "details-container"
    }, [_c('div', {
      staticClass: "asset-distribution"
    }, [_c('apexchart', {
      attrs: {
        "type": "bar",
        "height": "300",
        "options": _vm.getCustodianBarChartOptions(custodian.name),
        "series": _vm.getCustodianBarChartSeries(custodian.addressKey)
      }
    }), _vm.hasSmallValues(custodian.addressKey) ? _c('div', {
      staticClass: "small-value-indicator"
    }, [_vm._v(" * Some values may not be clearly visible due to scale differences. ")]) : _vm._e()], 1), _c('div', {
      staticClass: "asset-table"
    }, [_c('table', {
      staticClass: "assets-table"
    }, [_vm._m(4, true), _c('tbody', [_vm._l(_vm.assets, function (asset) {
      return _vm.checkBalance(custodian.addressKey, asset.balanceKey) ? _c('tr', {
        key: "".concat(custodian.id, "-").concat(asset.id)
      }, [_c('td', [_vm._v(_vm._s(asset.name))]), _c('td', [_vm._v(" " + _vm._s(_vm.formatValue(_vm.getBalanceValue(asset.balanceKey, custodian.addressKey, 6))) + " ")])]) : _vm._e();
    }), _c('tr', {
      staticClass: "subtotal-row"
    }, [_c('td', [_vm._v(_vm._s(custodian.name) + " Total")]), _c('td', [_vm._v(" " + _vm._s(_vm.formatPreciseValue(_vm.calculateExchangeTotal(custodian.addressKey))) + " ")])])], 2)])])])]);
  }), 0)])])])]) : _c('vue-loaders-ball-beat', {
    staticClass: "table-loader",
    attrs: {
      "color": "var(--redstone-red-color)",
      "scale": "0.5"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pull-model"
  }, [_c('div', {
    staticClass: "pull-model__view-details"
  }, [_c('h1', [_vm._v("RedStone USDtb Proof of Reserve (PoR)")]), _c('p', [_vm._v(" Provides transparent verification of assets backing Ethena’s USDtb across multiple custodians and contracts. ")]), _vm._v(" See USDtb and BlackRock BUIDL price feeds "), _c('a', {
    attrs: {
      "href": "https://app.redstone.finance/app/feeds/?page=1&sortBy=popularity&sortDesc=false&perPage=32&cryptos=BUIDL_FUNDAMENTAL,BUIDL_I_ETHEREUM_FUNDAMENTAL,BUIDL_ARBITRUM_FUNDAMENTAL,BUIDL_I_ETHEREUM_DAILY_ACCRUAL,BUIDL_ARBITRUM_DAILY_ACCRUAL,BUIDL_OPTIMISM_FUNDAMENTAL,BUIDL_OPTIMISM_DAILY_ACCRUAL,BUIDL_POLYGON_FUNDAMENTAL,BUIDL_POLYGON_DAILY_ACCRUAL,BUIDL_SOLANA_FUNDAMENTAL,BUIDL_AVALANCHE_DAILY_ACCRUAL,BUIDL_AVALANCHE_FUNDAMENTAL,BUIDL_SOLANA_DAILY_ACCRUAL,BUIDL_DAILY_INTEREST_ACCRUAL,USDtb_FUNDAMENTAL",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(". ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-header"
  }, [_c('h2', [_vm._v("Asset Distribution")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-header"
  }, [_c('h2', [_vm._v("Custodians Distribution")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-header"
  }, [_c('h2', [_vm._v("Assets in Motion")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Asset")]), _c('th', [_vm._v("Value")])])]);

}]

export { render, staticRenderFns }